import { createRoot } from 'react-dom/client'

import initRoutes from './routes/initRoutes'

import App from './app'
import syncSession from './auth/syncSession'
import './i18n'
import './index.css'
import reportWebVitals from './reportWebVitals'

import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'

dayjs.extend(weekday)
dayjs.extend(localeData)

// Make sure that a session is loaded before starting the application.
// This prevents the user of needing to log in for each browser tab.
syncSession().then(() => {
    initRoutes().then(() => {
        // If you want to start measuring performance in your app, pass a function
        // to log results (for example: reportWebVitals(console.log))
        // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
        reportWebVitals()

        // Browser is polyfilled, start application.
        createRoot(document.getElementById('root')).render(<App />)
    })
})
